import { colors, Row, Cell } from '@dexma/ui-components';
import styled from 'styled-components';

export const StyledWidgetTextInput = styled.div<{ $error: boolean }>`
    padding: 20px 30px 0px 30px;
    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .form-control-input,
    .form-control-textarea {
        border-color: ${(props) => props.$error && colors.red};
    }

    .error {
        color: ${colors.red};
        text-align: left;
    }
`;

export const StyledRowActivableInput = styled(Row)`
    justify-content: space-between;
`;

export const StyledCellActivableInput = styled(Cell)`
    margin-right: 1.5rem;
`;

export const StyledWidgetTextFooterInput = styled.div`
    margin-top: 8px;
    line-height: 14px;
    font-size: 12px;
    font-weight: 400;
    color: ${colors.gray500};
`;
